import { render, staticRenderFns } from "./sfc.vue?vue&type=template&id=b00463da&"
import script from "./sfc.vue?vue&type=script&lang=js&"
export * from "./sfc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports